import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AppLinksFooter from './AppLinksFooter';
import { isMobilePlatform } from '../utils/platform';

const PublicPageLayout = ({ title, subtitle, children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const hideBack = isMobilePlatform(location.search);

  return (
    <div className="min-h-screen bg-gray-50">
      <div
        style={{ background: 'linear-gradient(to right, #22d3ee, #0891b2)', position: 'relative' }}
        className="py-12 px-6"
      >
        <div className="max-w-4xl mx-auto text-center">
          {!hideBack && (
          <button
            onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/admin/login'))}
            style={{
              position: 'absolute',
              top: '24px',
              left: '24px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: 'rgba(255,255,255,0.9)',
              fontSize: '14px',
              fontWeight: 500,
              padding: 0,
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
            Back
          </button>
          )}
          <img
            src={`${process.env.PUBLIC_URL}/images/logo.png`}
            alt="GUFFPUFF"
            className="h-16 mx-auto mb-4"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <h1 className="text-3xl font-bold text-white">{title}</h1>
          {subtitle && <p className="text-cyan-100 mt-2 text-sm">{subtitle}</p>}
        </div>
      </div>

      <div className="max-w-4xl mx-auto py-10 px-6">
        <div className="bg-white rounded-2xl shadow-sm p-8">{children}</div>
      </div>

      <div className="text-center py-6 text-sm text-gray-400 space-y-3">
        <AppLinksFooter variant="muted" />
        <p>&copy; {new Date().getFullYear()} GuffPuff. All rights reserved.</p>
      </div>
    </div>
  );
};

export default PublicPageLayout;
